import { inject, injectable } from "inversify";
import { DI } from "../../infrastructure/di";
import { Request } from "../../infrastructure/request";
import { RequestDispatcher } from "../../infrastructure/request-dispatcher";

@injectable()
export class HtmlRepository {

	constructor(
		@inject(DI.REQUEST_DISPATCHER) private requestDispatcher: RequestDispatcher
	) {
	}

	public async get(request: Request): Promise<any> {

		const response = await this.requestDispatcher.execute(request);

		return response;
	}
}
